import axios from 'axios';
import { uuid } from 'vue-uuid';
import store from '../index';

const state = {
	words: [],
	country: [],
};

const getters = {
	getWords: state => {
		return state.words;
	},
	getCountry: state => {
		return state.country;
	},
};

const actions = {
	asyncFetchDataWord: async (context, settings) => {
		let url = 'graphs/word';
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						year: settings.year,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				//console.log(res.data.pagination);
				//context.commit('setWords', res.data.data);
				return res.data.data;
				//resolve(res);
			})
			.catch(err => {
				console.log('errore', err);
				/*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
			});
	},
	asyncFetchDataCountry: async (context, settings) => {
		let url = 'graphs/country';

		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						year: settings.year,
						country: settings.country,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				//console.log(res.data.pagination);
				// context.commit('setCountry', res.data.data);
				return res.data.data;
				//resolve(res);
			})
			.catch(err => {
				console.log('errore', err);
				/*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
			});
	},
	asyncFetchDataOrder: async (context, settings) => {
		let url = 'graphs/orders';
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						year: settings.year,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)
			.then(res => {
				//console.log(res.data.pagination);
				// context.commit('setCountry', res.data.data);
				return res.data.data;
				//resolve(res);
			})
			.catch(err => {
				console.log('errore', err);
				/*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
			});
	},
	asyncFetchFrontEnd: async (context, settings) => {
		let url = 'it/';
		return await axios
			.get(
				`${process.env.VUE_APP_URL_SOCKET}web/v1/it/home`,

				{
					headers: {
						Authorization: `Bearer ${context.rootGetters['profile/getToken']}`,
						platform: `${context.rootGetters['profile/getProfile']}`,
						lang: 'it',
						uuid: uuid.v4(),
						'Access-Control-Request-Headers': 'authorization,lang,platform,uuid',
					},
					'Content-Type': 'application/json',
				},
			)
			.then(res => {
				//console.log(res.data.pagination);
				// context.commit('setCountry', res.data.data);
				return res.data.data;
				//resolve(res);
			})
			.catch(err => {
				console.log('errore', err);
				/*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
			});
	},

	destroyData: context => {
		context.commit('setWords', []);
		context.commit('setCountry', []);
	},
};

const mutations = {
	setWords: (state, value) => {
		state.words = value;
	},
	setCountry: (state, value) => {
		state.country = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
